// extracted by mini-css-extract-plugin
export default {"sidebarLink":"_SideBarLink_sidebarLink__dUX+y"};